<script setup>
// Le Reel de présentation (45 s, vertical) : démarre sans son quand il arrive à l'écran, se met en pause hors écran ;
// le bouton (ou un toucher sur la vidéo) active la voix et la musique depuis le début. Mouvement réduit : image d'attente seulement.
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { Volume2, VolumeX } from 'lucide-vue-next';

// tuile : la vidéo remplit la tuile bento qui la contient (coins et ombre portés par la tuile)
defineProps({ tuile: { type: Boolean, default: false } });
const video = ref(null);
const muet = ref(true);
let observer = null;

onMounted(() => {
  const el = video.value;
  if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) el.play().catch(() => {});
    else el.pause();
  }, { threshold: 0.4 });
  observer.observe(el);
});

onBeforeUnmount(() => observer?.disconnect());

function basculerSon() {
  const el = video.value;
  if (!el) return;
  muet.value = !muet.value;
  el.muted = muet.value;
  if (!muet.value) { el.currentTime = 0; el.play().catch(() => {}); }
}
</script>

<template>
  <div class="relative">
    <video ref="video" muted loop playsinline preload="none" poster="/videos/reel-clocook-poster.jpg"
           aria-label="Vidéo de présentation de Clo'Cook" class="w-full object-cover bg-[#fdf6e3] cursor-pointer"
           :class="tuile ? 'aspect-[9/16] block' : 'aspect-[9/16] rounded-[24px] shadow-lg'"
           @click="basculerSon">
      <source src="/videos/reel-clocook.webm" type="video/webm" />
      <source src="/videos/reel-clocook.mp4" type="video/mp4" />
    </video>
    <button type="button" @click="basculerSon" :aria-label="muet ? 'Activer le son' : 'Couper le son'"
            class="absolute bottom-4 right-4 flex items-center gap-1.5 bg-[#111]/80 text-white text-xs font-bold px-3 py-2 rounded-full active:scale-95 transition-transform">
      <VolumeX v-if="muet" class="w-4 h-4" /><Volume2 v-else class="w-4 h-4" />
      {{ muet ? 'Activer le son' : 'Son activé' }}
    </button>
  </div>
</template>
